<template>
  <div class="law-page">
    <div class="top-banner">
      <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg.png" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="title">智慧法规库</div>
        <div class="space"></div>
        <div class="info">医疗器械法规体系复杂且动态更新，不同国家/地区的侧重点可能不同，但核心目标均为保障产品安全有效。</div>
        <div class="info">簙引辅助企业结合产品特性和目标市场，系统理解各环节法规要求，以确保合规运营。</div>
        <div class="btn">
          <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/btn.png" class="btn" alt="">
        </div>
      </div>
    </div>

    <div class="law-main">
      <div class="section-title">
        <h2>生命周期全覆盖</h2>
        <div class="title-underline"></div>
      </div>
      
      <div class="cards-container">
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">监管框架与基本法</h3>
          </div>
          <p class="card-description">确立医疗器械监管的基本原则、监管体系、责任主体和法律效力。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国《医疗器械监督管理条例》
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              美国《联邦食品、药品和化妆品法案》（FD&C Act）
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              欧盟《医疗器械法规》（MDR）和《体外诊断医疗器械法规》（IVDR）
            </li>
          </ul>
        </div>
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">生产质量管理规范（GMP）</h3>
          </div>
          <p class="card-description">规范生产环节的质量管理体系，确保产品安全性和一致性。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国《医疗器械生产质量管理规范》
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              美国FDA 21 CFR Part 820（质量体系法规，QSR）
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              欧盟ISO 13485标准。
            </li>
          </ul>
        </div>
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">标准与技术要求</h3>
          </div>
          <p class="card-description">制定产品性能、安全性和测试方法的技术标准。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              国际标准（ISO 10993生物相容性标准）。
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国国家标准（GB系列）和行业标准（YY系列）全套
            </li>
          </ul>
        </div>
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">伦理与临床要求</h3>
          </div>
          <p class="card-description">规范临床试验伦理审查、受试者保护及数据真实性。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国《医疗器械临床试验质量管理规范》
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              美国《临床试验知情同意规则》（21 CFR Part 50）
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              欧盟MDR对临床证据的强化要求。
            </li>
          </ul>
        </div>
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">经营与使用监管</h3>
          </div>
          <p class="card-description">管理流通环节（如经营许可）及医疗机构的使用规范。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国《医疗器械经营监督管理办法》
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              美国对分销商的注册要求。
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              欧盟对进口商和分销商的追溯责任。
            </li>
          </ul>
        </div>
        <div class="card">
          <div class="card-header">
            <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/icon-law.png" alt="Card Icon" class="card-icon" />
            <h3 class="card-title">上市后监管与不良事件监测</h3>
          </div>
          <p class="card-description">要求企业建立不良事件报告、召回和再评价制度。</p>
          <ul class="card-list">
            <li class="card-list-item">
              <span class="bullet-point"></span>
              中国《医疗器械不良事件监测和再评价管理办法》
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              美国MedWatch系统和MAUDE数据库。
            </li>
            <li class="card-list-item">
              <span class="bullet-point"></span>
              欧盟的警戒（Vigilance）系统。
            </li>
          </ul>
        </div>
      </div>

      <div class="section-title">
        <h2>法规高效追踪</h2>
        <div class="title-underline"></div>
      </div>

      <div class="law-table">
        <Swipe :autoplay="5000" :loop="true" :touchable="true" :show-indicators="false">
          <SwipeItem>
            <div class="banner-item">
              <div class="info">
                <div class="title">国内法规即时掌握</div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    抓取范围广
                  </div>
                  <div class="desc">覆盖全国50+官方机构。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    每日更新
                  </div>
                  <div class="desc">当日法规次日达，效率与质量并重。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    自动关联
                  </div>
                  <div class="desc">新旧版文件在库内自动关联，辅助拓展知识图谱。</div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/law1.png" class="table-bg" alt="" @dragstart.prevent>
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/law-item1.png" class="item-img" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
          <SwipeItem>
            <div class="banner-item">
              <div class="info">
                <div class="title">全球法规一触即达</div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    精准识别
                  </div>
                  <div class="desc">专注于医疗器械法规抓取，对监管动态做到实时分析。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    在线下载
                  </div>
                  <div class="desc">库内所有法规文件均支持在线下载。</div>
                </div>
                <div class="item">
                  <div class="label">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    在线翻译
                  </div>
                  <div class="desc">平台拥有专业术语库，支持多语言文件翻译，复杂语言不再是阻碍。</div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/law2.png"  class="table-bg" alt="" @dragstart.prevent>
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/law-item2.png" class="item-img" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
        </Swipe>
      </div>

      <div class="section-title">
        <h2>专研AI在线解答</h2>
        <div class="title-underline"></div>
      </div>

      <div class="ai-box"> 
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/ai.png" alt="" class="ai">
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/ai-bg.png" alt="" class="ai-bg">
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swipe, SwipeItem, Icon } from 'vant';
import '@vant/touch-emulator'
</script>

<style lang="less" scoped>
.law-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  
  .banner-info {
    position: absolute;
    right: 100px;
    top: 0;
    height: 600px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    
    .title {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 90px;
      color: #101010;
    }
    
    .space {
      width: 160px;
      height: 24px;
      margin: 32px 0 44px;
      background: linear-gradient(228.23deg, rgba(35,19,176,0.83) 12.42%,rgba(128,152,219,0.9) 47.6%,rgba(135,183,219,0.82) 73.98%,rgba(165,227,255,0.75) 97.43%);
    }
    
    .info {
      
      font-size: 20px;
      line-height: 35px;
      color: #101010;
      text-align: right;
    }
    
    .btn {
      margin-top: 40px;
      
      img {
        width: 200px;
        cursor: pointer;
        transition: all .3s;
        
        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;
    
    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .law-main {
    padding: 60px 0;
    
    .section-title {
      text-align: center;
      margin-bottom: 60px;
      
      h2 {
        
        font-size: 48px;
        color: #101010;
        margin-bottom: 10px;
      }
      
      .title-underline {
        width: 440px;
        height: 7px;
        background: #1e40af;
        margin: 0 auto;
      }
    }

    .cards-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;
      width: 1400px;
      margin: 0 auto 80px;
      padding: 0 20px;
    }

    .card {
      height: 380px;
      background: #fff;
      border-radius: 12px;
      padding: 30px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      text-align: left;
      color: rgba(16, 16, 16, .7);
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
      }
      
      .card-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        
        .card-icon {
          width: 48px;
          height: 48px;
          margin-right: 18px;
        }
        
        .card-title {
          
          font-size: 24px;
          color: #101010;
          font-weight: 600;
        }
      }
      
      .card-description {
        
        font-size: 18px;
        line-height: 28px;
        margin-bottom: 20px;
      }
      
      .card-list {
        list-style: none;
        padding: 0;
        margin: 0;
        
        .card-list-item {
          
          font-size: 16px;
          margin-bottom: 12px;
          display: flex;
          align-items: flex-start;
          
          .bullet-point {
            width: 8px;
            height: 8px;
            background: #3b82f6;
            border-radius: 50%;
            margin-right: 12px;
            margin-top: 10px;
            flex-shrink: 0;
          }
        }
      }
    }
  }


  .law-table {
    width: 1400px;
    height: 600px;
    margin: 0 auto 80px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 24px;
    overflow: hidden;
    .banner-item {
      display: flex;
      .info {
        width: 30%;
        padding: 60px 65px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        
        color: #101010;
        font-size: 18px;
        .title {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 60px;
        }
        .item {
          text-align: left;
          & + .item {
            margin-top: 40px;
          }
          .label {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 10px;
            .van-icon {
              margin-right: 10px;
            }
          }
        }
      }
      .bg-box {
        position: relative;
        width: 70%;
        height: 598px;
        background: linear-gradient(-45.17deg, rgba(187,216,255,0.82) 6.23%,rgba(171,241,255,0.38) 59.01%,rgba(253,247,244,0.81) 93.87%);
        padding: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        .table-bg {
          height: 480px;
          width: 100%;
        }
        .item-img {
          position: absolute;
          left: 30px;
          bottom: 50px;
          width: 340px;
        }
      }
    }
  }

  .ai-box {
    width: 1400px;
    margin: 0 auto;
    position: relative;
    .ai-bg {
      position: absolute;
      left: 0;
      top: 50px;
      width: 100%;
    }
    .ai {
      position: relative;
      z-index: 2;
      width: 1200px;
      margin: 0 auto;
      transform: translateX(-40px);
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1560px) {
  .law-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .title {
          font-size: 66px;
          line-height: 84px;
        }
        .space {
          height: 22px;
        }
        .info {
          font-size: 18px;
        }
        .btn {
          margin-top: 34px;
        }
      }
    }

    .law-main {
      padding-top: 52px;
      .section-title {
        margin-bottom: 52px;
        h2 {
          font-size: 42px;
        }
        .title-underline {
          width: 380px;
          height: 6px
        }
      }
      .cards-container {
        width: 1200px;
      }
      .card {
        height: 340px;
        padding: 24px;
        .card-header {
          margin-bottom: 16px;
          .card-icon {
            width: 42px;
            height: 42px;
            margin-right: 16px;
          }
          .card-title {
            font-size: 21px;
          }
        }
        .card-description {
          font-size: 17px;
          line-height: 24px;
        }
        .card-list {
          .card-list-item {
            font-size: 15px;
          }
        }
      }
    }

    .law-table {
      width: 1200px;
      height: 520px;
      margin-bottom: 70px;
      .banner-item {
        .info {
          padding: 40px 45px;
          font-size: 16px;
          .title {
            font-size: 24px;
            margin-bottom: 48px;
          }
          .item {
            & + .item {
              margin-top: 32px;
            }
            .label {
              font-size: 18px;
            }
          }
        }
        .bg-box {
          height: 518px;
          .table-bg {
            height: 416px;
          }
          .item-img {
            width: 280px;
          }
        }
      }
    }

    .ai-box {
      width: 1200px;
      .ai {
        width: 960px;
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .law-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .title {
          font-size: 60px;
          line-height: 72px;
        }
        .space {
          height: 20px;
        }
        .info {
          font-size: 16px;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .law-main {
      padding-top: 46px;
      .section-title {
        margin-bottom: 36px;
        h2 {
          font-size: 36px;
        }
        .title-underline {
          width: 350px;
          height: 5px
        }
      }
      .cards-container {
        width: 1080px;
      }
      .card {
        height: 320px;
        padding: 20px;
        .card-header {
          margin-bottom: 14px;
          .card-icon {
            width: 38px;
            height: 38px;
            margin-right: 14px;
          }
          .card-title {
            font-size: 19px;
          }
        }
        .card-description {
          font-size: 15px;
          line-height: 22px;
        }
        .card-list {
          .card-list-item {
            font-size: 15px;
          }
        }
      }
    }

    .law-table {
      width: 1080px;
      height: 480px;
      margin-bottom: 60px;
      .banner-item {
        .info {
          padding: 30px 33px;
          font-size: 14px;
          .title {
            font-size: 20px;
            margin-bottom: 40px;
          }
          .item {
            & + .item {
              margin-top: 26px;
            }
            .label {
              font-size: 16px;
            }
          }
        }
        .bg-box {
          height: 478px;
          .table-bg {
            height: 384px;
          }
          .item-img {
            width: 250px;
          }
        }
      }
    }

    .ai-box {
      width: 1080px;
      .ai {
        width: 864px;
      }
    }
  }
}
</style>